// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.bonuz",
    name: "Bonuz Social Smart Wallet",
    homepage: "https://bonuz.xyz",
    image_id: "eb376138-c5b9-4d82-c610-c98c9c218a00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/eg/app/bonuz-social-smart-wallet/id1637687439",
        android: "https://play.google.com/store/apps/details?id=market.bonuz.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bonuzapp://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map